import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchUsers_api = async (page = 1, limit = 10, search = "") => {
    try {
        const response = await axios.get(`${SERVER_API}/Users/fetch_users.php`, {
            params: { page, limit, search }
        });
        return response.data;
    } catch (error: any) {
        console.error("Fetch users failed:", error);
        return { error: "Fetch users failed" };
    }
};

export const FetchUserTypes_api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Users/fetch_user_types.php`);
        return response.data;
    } catch (error: any) {
        console.error("Fetch user types failed:", error);
        return { error: "Fetch user types failed" };
    }
};

export const FetchAppFeatures_api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Users/fetch_app_features.php`);
        return response.data;
    } catch (error: any) {
        console.error("Fetch app features failed:", error);
        return { error: "Fetch app features failed" };
    }
};

export const AddUser_api = async (data: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(data));

        const response = await axios.post(`${SERVER_API}/Users/add_user.php`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        console.error("Add user failed:", error);
        return { error: "Add user failed" };
    }
};

export const UpdateUser_api = async (data: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(data));

        const response = await axios.post(`${SERVER_API}/Users/update_user.php`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        console.error("Update user failed:", error);
        return { error: "Update user failed" };
    }
};

export const UpdateUserStatus_api = async (userId: string, status: number, adminId?: number) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify({ user_id: userId, status, adminId }));

        const response = await axios.post(
            `${SERVER_API}/Users/update_user_status.php`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Update user status failed:", error);
        return { error: "Update user status failed" };
    }
};

export const FetchUserPermissions_api = async (userId: string) => {
    try {
        const response = await axios.get(
            `${SERVER_API}/Users/fetch_user_permissions.php?user_id=${userId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Fetch user permissions failed:", error);
        return { error: "Fetch user permissions failed" };
    }
};

export const UpdateUserPermissions_api = async (userId: string, featureIds: number[], adminId?: number) => {
    try {
        const formData = new FormData();
        formData.append(
            "inputs",
            JSON.stringify({ user_id: userId, feature_ids: featureIds, adminId })
        );

        const response = await axios.post(
            `${SERVER_API}/Users/update_user_permissions.php`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Update user permissions failed:", error);
        return { error: "Update user permissions failed" };
    }
};

export const FetchSystemLogs_api = async (page = 1, limit = 10, search = "") => {
    try {
        const response = await axios.get(`${SERVER_API}/Users/fetch_system_logs.php`, {
            params: { page, limit, search }
        });
        return response.data;
    } catch (error: any) {
        console.error("Fetch system logs failed:", error);
        return { error: "Fetch system logs failed" };
    }
};

export const AddSystemLog_api = async (log: any) => {
    try {
        const response = await axios.post(`${SERVER_API}/Users/add_system_log.php`, log);
        return response.data;
    } catch (error: any) {
        console.error("Logging failed", error);
    }
};

export const FetchAppFeatureCategories_api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Users/fetch_app_feature_categories.php`);
        return response.data;
    } catch (error: any) {
        console.error("Fetch app feature categories failed:", error);
        return { error: "Fetch app feature categories failed" };
    }
};

export const AddAppFeatureCategory_api = async (data: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(data));

        const response = await axios.post(`${SERVER_API}/Users/add_app_feature_category.php`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        console.error("Add app feature category failed:", error);
        return { error: "Add app feature category failed" };
    }
};

export const AddAppFeature_api = async (data: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(data));

        const response = await axios.post(`${SERVER_API}/Users/add_app_feature.php`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        console.error("Add app feature failed:", error);
        return { error: "Add app feature failed" };
    }
};
